<template>
  <div class="encuestas">
    <b-navbar type="dark" variant="utb-blue" fixed="top">
      <b-navbar-brand href="#">
        <img src="images/logo_utb_blanco.png" alt="Logo" class="d-inline-block align-top" />
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-text>{{ $oauth.data.sub }} {{ $oauth.data.name ? $oauth.data.name : ''}}</b-nav-text>
      </b-navbar-nav>
    </b-navbar>
    <b-container class="mt-3 clear-navbar">
      <h2 class="app-name text-center text-primary">Actualiza UTB</h2>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)" @reset="onReset" novalidate autocomplete="off">
          <div role="tablist">
            <b-card v-for="grupo in grupos" :key="grupo.id" no-body>
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf(grupo.identificador))" block :disabled="!actives.includes(grupo.identificador)">{{ grupo.nombre }}</b-button>
              </b-card-header>
              <b-collapse :id="grupo.identificador" accordion="accordion" role="tabpanel" :visible="visible === grupo.identificador">
                <b-card-body v-if="visible === grupo.identificador">
                  <template v-for="(pregunta, index) in preguntasGrupo(grupo.id)">
                    <template v-if="pregunta.tipo == 'documento' || pregunta.tipo == 'imagen'">
                      <component :key="index" :is="pregunta.tipo" :id="pregunta.identificador" :texto="pregunta.texto" :ayuda="pregunta.ayuda" :meta="pregunta.meta" :requerida="pregunta.requerida && !respuestas[pregunta.identificador]" v-model="respuestas[pregunta.identificador]" v-if="pregunta.mostrar && evaluarCondicion(pregunta)">
                      </component>
                    </template>
                    <template v-else-if="pregunta.tipo != 'parrafo'">
                      <component :key="index" :is="pregunta.tipo" :id="pregunta.identificador" :texto="pregunta.texto" :ayuda="pregunta.ayuda" :meta="pregunta.meta" :requerida="pregunta.requerida" v-model="respuestas[pregunta.identificador]" v-if="pregunta.mostrar && evaluarCondicion(pregunta)">
                      </component>
                    </template>
                    <template v-else>
                      <component :key="index" :is="pregunta.tipo" :id="pregunta.identificador" :texto="pregunta.texto" :ayuda="pregunta.ayuda" v-model="respuestas[pregunta.identificador]">
                      </component>
                    </template>
                  </template>
                </b-card-body>
                <b-card-footer>
                  <b-button class="ml-auto" variant="info" style="display:block" @click.stop.prevent="handleSubmit(siguiente)">
                    Seguir
                    <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
            <b-card no-body>
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button variant="link" size="lg" @click.prevent="abrirTab(visibles.indexOf('__confirmarEnvio'))" block :disabled="!actives.includes('__confirmarEnvio')">Confirmar envío</b-button>
              </b-card-header>
              <b-collapse id="confirmar-envio" accordion="accordion" role="tabpanel" :visible="visible === '__confirmarEnvio'">
                <b-card-body v-if="visible === '__confirmarEnvio'">
                  <p>Haciendo clic en el botón enviar declara que todos los datos registrados antriormente se ajustan a la verdad.</p>
                </b-card-body>
                <b-card-footer>
                  <b-button type="submit" variant="success" class="ml-auto" style="display:block" :disabled="visible !== '__confirmarEnvio' || disabled">
                    Enviar
                    <b-icon icon="hand-thumbs-up"></b-icon>
                  </b-button>
                </b-card-footer>
              </b-collapse>
            </b-card>
          </div>
        </b-form>
      </validation-observer>
      <div class="fixed-bottom">
        <b-container>
          <b-progress variant="success" max="100" height="2rem" striped>
            <b-progress-bar :value="progress" :label="`${progress.toFixed(0)}%`"></b-progress-bar>
          </b-progress>
        </b-container>
      </div>
    </b-container>
  </div>
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios'
import _ from 'lodash'
import { session, set } from 'store2'
import { Vue, Component, Watch } from 'vue-property-decorator'

import { url } from '../../services/url_service'
import { redirect } from '../../services/redirect_service'

import settings from '../../settings'

import Texto from '../../components/tipos/texto.vue'
import Fecha from '../../components/tipos/fecha.vue'
import Email from '../../components/tipos/email.vue'
import Celular from '../../components/tipos/celular.vue'
import Entero from '../../components/tipos/entero.vue'
import Decimal from '../../components/tipos/decimal.vue'
import Sino from '../../components/tipos/sino.vue'
import MRadio from '../../components/tipos/radio.vue'
import MSelect from '../../components/tipos/select.vue'
import MCheck from '../../components/tipos/check.vue'
import Direccion from '../../components/tipos/direccion.vue'
import Documento from '../../components/tipos/documento.vue'
import Imagen from '../../components/tipos/imagen.vue'
import Parrafo from '../../components/tipos/parrafo.vue'
import Politicas from '../../components/tipos/politicas.vue'

@Component({
  components: {
    Texto,
    Fecha,
    Email,
    Celular,
    Entero,
    Decimal,
    Sino,
    MRadio,
    MSelect,
    MCheck,
    Direccion,
    Documento,
    Imagen,
    Parrafo,
    Politicas
  },
})
export default class Dinamica extends Vue {
  public encuestaId?: number = null
  public encuesta?: any = {}
  public visible: string = null
  public step: number = 0
  public actives: Array<string> = []
  public visibles: Array<string> = []
  public preguntas: Array<any> = []
  public grupos: Array<any> = []
  public respuestas: any = {}
  public respuestasOcultas: any = {}
  public disabled: boolean = false

  get progress() {
    return ((this.actives.length - 1) / (this.visibles.length - 1)) * 100
  }

  public async onSubmit() {
    this.disabled = true
    try {
      let response = await axios.post(
        url.create(`/external/dinamicas/${this.encuestaId}/respuestas`),
        this.respuestas
      )
      this.onReset()
      session.clear()

      if (this.encuesta.tipo === 'INGRESO') {
        var data = response.data
        if (data['email_enviado'] == 'ENVIADO') {
          this.$router.push({ name: 'codigoEnviado' })
        } else if (data['email_enviado'] == 'ALERTAS') {
          this.$router.push({ name: 'codigoAlertas' })
        } else {
          this.$router.push({ name: 'codigoNoEnviado' })
        }
      } else {
        this.$router.push({ name: 'gracias' })
      }

    } catch (e) {
      let message = 'Los datos de tu encuesta no pudieron ser guardados, por favor contacte al administrador'
      if (e.response) {
        if (e.response.status === 401) {
          message = 'La sesión ha caducado, por favor ingresa nuevamente'
        } else if (e.response.status === 409) {
          message = 'Por favor revisa los datos, hay inconsistencias'
        } else if (e.response.status === 420) {
          message = e.response.data.message
        } else if (e.response.status === 500) {
          message = 'Ha ocurrido un error en el servidor, por favor contacta al administrador del sistema'
        }
      }

      this.$bvToast.toast(
        message,
        {
          title: 'Ha ocurrido un error',
          variant: 'danger',
        }
      )
      this.disabled = false
    }
  }

  public onReset() {
    this.$refs.observer['reset']()
    this.disabled = false
  }

  public preguntasGrupo(id: number) {
    return this.preguntas.filter(function (preguntas) {
      return preguntas.grupo_id === id
    })
  }

  public async abrirTab(step: number) {
    this.step = step
    this.visible = this.visibles[this.step]
    session.set(
      `encuesta_${this.encuesta.id}_${this.$oauth.data.sub}`,
      this.respuestas,
      true
    )
  }

  public async siguiente() {
    if (this.step < this.visibles.length - 1) {
      this.step++
      this.visible = this.visibles[this.step]
      if (!this.actives.includes(this.visible)) {
        this.actives.push(this.visible)
        session.set(
          `encuesta_${this.encuesta.id}_actives_${this.$oauth.data.sub}`,
          this.actives,
          true
        )
      }
      session.set(
        `encuesta_${this.encuesta.id}_${this.$oauth.data.sub}`,
        this.respuestas,
        true
      )
    } else {
    }
  }

  public async cargarEncuesta() {
    let response = await axios.get(
      url.create(`/external/dinamicas/${this.encuestaId}`)
    )
    this.encuesta = response.data

    if (this.encuesta.estado !== 'ACTIVA') {
      this.$router.push({ name: 'encuesta-inactiva' })
    }
  }

  public async cargarPreguntas() {
    let response = await axios.get(
      url.create(`/external/dinamicas/${this.encuestaId}/preguntas`)
    )
    this.preguntas = response.data

    response = await axios.get(
      url.create(`/external/dinamicas/${this.encuestaId}/grupos`)
    )
    let self = this
    this.grupos = response.data.filter(function (grupo) {
      return self.preguntas.some(pregunta => pregunta.grupo_id == grupo.id && pregunta.mostrar)
    })
    this.visibles = this.grupos
      .map(function (grupo) {
        return grupo.identificador
      })

    for (let pregunta of this.preguntas) {
      if (pregunta.mostrar) {
        this.respuestas[pregunta.identificador] = pregunta.inicial
      } else {
        this.respuestasOcultas[pregunta.identificador] = pregunta.inicial
      }
    }

    this.visibles.push('__confirmarEnvio')

    let actives = session.get(`encuesta_${this.encuesta.id}_actives_${this.$oauth.data.sub}`, [])
    let respuestas = session.get(`encuesta_${this.encuesta.id}_${this.$oauth.data.sub}`, {})

    this.respuestas = { ...this.respuestas, ...respuestas }

    //Obtener los activos de la sesion

    this.step = 0
    //this.actives.clear()
    this.visible = this.visibles[this.step]
    if (actives.length > 0) {
      this.actives = actives
    } else {
      this.actives = [this.visible]
    }
  }

  public evaluarCondicion(pregunta) {
    if (!_.isEmpty(pregunta.condicion)) {
      if (
        !settings.operadores[pregunta.condicion.operador].eval(
          this.respuestas[pregunta.condicion.identificador] || this.respuestasOcultas[pregunta.condicion.identificador],
          pregunta.condicion.valor === 'NULL' ? null : pregunta.condicion.valor
        )
      ) {
        this.respuestas[pregunta.identificador] = null
        return false
      }
    }
    return true
  }

  created() {
    this.encuestaId = parseInt(this.$route.params['id'])
    this.cargarEncuesta()
    this.cargarPreguntas()
  }
}
</script>

<style lang="scss">
.encuestas {
  & .custom-select option:not(:first-child),
  & .custom-select.is-valid {
    text-transform: uppercase;
  }
}
</style>
